import { render, staticRenderFns } from "./ViolationRecord.vue?vue&type=template&id=96d7687e&scoped=true&"
import script from "./ViolationRecord.vue?vue&type=script&lang=js&"
export * from "./ViolationRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d7687e",
  null
  
)

export default component.exports